import Skeleton from "react-loading-skeleton";
import { CATEGORY_LINK_SKELETON_COUNT } from "../libs/categoryIcons";

const LINE_WIDTHS = ["88%", "76%", "82%", "70%", "85%", "74%", "80%", "72%", "86%", "78%", "83%", "75%", "84%", "71%"];

const CategorySidebarSkeleton = () => (
  <div className="market-category-skeleton" aria-hidden="true">
    <Skeleton height={16} width="55%" borderRadius={6} className="market-category-skeleton__heading" />
    {Array.from({ length: CATEGORY_LINK_SKELETON_COUNT }).map((_, index) => (
      <div className="market-category-skeleton__row" key={index}>
        <Skeleton circle width={20} height={20} />
        <Skeleton
          height={14}
          width={LINE_WIDTHS[index % LINE_WIDTHS.length]}
          borderRadius={6}
        />
      </div>
    ))}
  </div>
);

export default CategorySidebarSkeleton;
